import { createSelector } from 'reselect';
import { studyDocumentsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const studyDocumentsSelectorYearsSelector = createSelector(studyDocumentsSelector, (studyDocuments) =>
  extractDatesFromNestedItems(studyDocuments?.content, [
    {
      type: 'date',
      field: 'issueDate',
    },
  ]),
);
